<script lang="ts">
	import Labelled from "@components/form/Labelled.svelte";
	import Select from "@components/form/Select.svelte";
	import type { ComponentProps, Snippet } from "svelte";
	import type { ClassValue, HTMLLabelAttributes } from "svelte/elements";

	let {
		value = $bindable(),
		/* eslint-disable prefer-const */
		wrapperClass,
		label,
		children,
		...rest
		/* eslint-enable prefer-const */
	}: ComponentProps<typeof Select> & {
		wrapperClass?: ClassValue;
		children: Snippet;
		label?: HTMLLabelAttributes;
	} = $props();

	const id = $derived(`${rest.id ?? rest.name ?? ""}-${crypto.randomUUID()}`);
</script>

<Labelled {wrapperClass} required={rest.required} label={{ ...label, for: id }}>
	{@render children()}
	{#snippet content()}
		<Select class="flex-1" {...rest} bind:value {id} />
	{/snippet}
</Labelled>
